import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/metadata`;

export class Metadata {
  static async fetchRepositories(params) {
    try {
      const response = await axios.get(`${BASE_URL}/repositories`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchRepository(repositoryId, params) {
    try {
      const response = await axios.get(
        `${BASE_URL}/repository/${repositoryId}`,
        {
          headers: Contexture.getHeaders(),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchFields(repositoryId, params) {
    try {
      const response = await axios.get(`${BASE_URL}/fields/${repositoryId}`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchObjectTypes(repositoryId, params) {
    try {
      const response = await axios.get(
        `${BASE_URL}/objectType/${repositoryId}`,
        {
          headers: Contexture.getHeaders(),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchObjectType(repositoryId, objectType, params) {
    try {
      const response = await axios.get(
        `${BASE_URL}/objectType/${repositoryId}/${objectType}`,
        {
          headers: Contexture.getHeaders(),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
